import gql from "graphql-tag";

export default gql`
	mutation disableUser($user_id: ID!) {
		disableUser(userId: $user_id) {
			success
		}
	}
`;
